import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import type { LanguageMetadata } from './types';
import { en, enMetadata } from './locales/en';
import { ru, ruMetadata } from './locales/ru';

export const languages: LanguageMetadata[] = [enMetadata, ruMetadata];

const resources = {
  en,
  ru,
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    interpolation: {
      escapeValue: false,
    },
    fallbackLng: enMetadata.code,
    debug: false,
  });

export { i18n };
